import React from "react";
import { Skeleton } from "@mui/material";
import styles from "../../../assets/styles/pageStyles/ruleBasedInbox/threadList/threadList.module.scss";

interface ThreadListItemSkeletonProps {
    style?: React.CSSProperties;
}

/**
 * Skeleton loader for Thread List Item
 * Shows animated placeholder while thread data is loading
 */
const ThreadListItemSkeleton: React.FC<ThreadListItemSkeletonProps> = ({ style }) => {
    return (
        <div
            style={style}
            className={styles.threadListItemSkeleton}
        >
            {/* WhatsApp Icon Skeleton */}
            <div className={styles.threadAvatar}>
                <Skeleton
                    variant="circular"
                    width={20}
                    height={20}
                    animation="wave"
                />
            </div>

            {/* Content Section */}
            <div className={styles.threadContent}>
                {/* Top Row: Name and Time */}
                <div className={styles.threadTopRow}>
                    <Skeleton
                        variant="text"
                        width="60%"
                        height={16}
                        animation="wave"
                        sx={{ fontSize: "14px" }}
                    />
                    <div className={styles.threadTimeContainer}>
                        <Skeleton
                            variant="text"
                            width={30}
                            height={14}
                            animation="wave"
                            sx={{ fontSize: "12px" }}
                        />
                        <Skeleton
                            variant="circular"
                            width={24}
                            height={24}
                            animation="wave"
                        />
                    </div>
                </div>

                {/* Phone Number Skeleton */}
                <Skeleton
                    variant="text"
                    width="40%"
                    height={14}
                    animation="wave"
                    sx={{ fontSize: "12px", marginTop: "4px" }}
                />

                {/* Last Message Skeleton */}
                <Skeleton
                    variant="text"
                    width="85%"
                    height={16}
                    animation="wave"
                    sx={{ fontSize: "13px", marginTop: "4px" }}
                />
            </div>
        </div>
    );
};

export default ThreadListItemSkeleton;

